import { render } from "./WordOptionsModal.vue?vue&type=template&id=86e43fc4"
import script from "./WordOptionsModal.vue?vue&type=script&lang=js"
export * from "./WordOptionsModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/amane/Documents/-4°/AmaneStudio/A++/Amane.dev/portfolio.amane.dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__